import classNames from 'classnames';
import React, { useCallback, useMemo, useRef } from 'react';
import { Checkbox as TPACheckbox } from 'wix-ui-tpa/cssVars';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { SelectMode } from '../../field-settings/settings-shared/options/options-list/types';
import { getSelectMode } from '../../fields/product-list/product-list-settings/select-mode-setting/get-select-mode';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import Fieldset from '../fieldset';
import { ProductWUT } from './product/product-wut';
import styles from './product-list.module.scss';
import { classes } from './product-list-wut.st.css';
import { useConfig } from '../../contexts/config-context';
import { getCurrencyAriaLabel } from '../shared/payment-field-utils';
import { useTranslation } from '../../contexts/translation-context';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const ProductListComponentWUT = props => {
  var _validation$predefine;
  const {
    id,
    target,
    description,
    required,
    hideLabel,
    label,
    options,
    value,
    error,
    hasError = false,
    errorMessage,
    onChange,
    onFocus,
    onBlur,
    imageResize,
    FieldLayout,
    validation,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = props;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const {
    currency
  } = useConfig();
  const {
    t
  } = useTranslation();
  const firstCheckboxRef = useRef(null);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const selectOptionsMode = getSelectMode(validation == null || (_validation$predefine = validation.predefined) == null ? void 0 : _validation$predefine.paymentOptions);
  const allowMany = selectOptionsMode === SelectMode.many;
  const _value = useMemo(() => value || [], [value]);
  const _onChange = useCallback(newValue => {
    onChange == null || onChange(newValue);
  }, [onChange]);
  const handleChange = useCallback((productValue, isChecked) => {
    const restProductValues = _value.filter(val => val.productId !== productValue.productId);
    const newProductValues = isChecked ? [...restProductValues, productValue] : restProductValues;
    _onChange(newProductValues);
  }, [_value, _onChange]);
  useFocusFieldEvent(() => {
    var _firstCheckboxRef$cur;
    (_firstCheckboxRef$cur = firstCheckboxRef.current) == null || _firstCheckboxRef$cur.focus({
      preventScroll: true
    });
  }, id);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(Fieldset, {
      id: inputId,
      ariaLabelledBy: labelId,
      className: classNames(styles.root),
      ariaDescribedBy: ariaDescribedBy,
      onFocus: onFocus,
      onBlur: onBlur,
      required: required,
      role: "group"
    }, options == null ? void 0 : options.map((option, index) => {
      var _validation$predefine2;
      const price = (validation == null || (_validation$predefine2 = validation.predefined) == null || (_validation$predefine2 = _validation$predefine2.paymentOptions) == null || (_validation$predefine2 = _validation$predefine2.products) == null || (_validation$predefine2 = _validation$predefine2.find(p => p.id === option.value)) == null || (_validation$predefine2 = _validation$predefine2.fixedPriceOptions) == null ? void 0 : _validation$predefine2.price) || '0';
      const currencyTranslation = getCurrencyAriaLabel(t, currency);
      const preselectedProduct = _value.find(i => i.productId === option.value);
      return allowMany ? /*#__PURE__*/React.createElement(ProductWUT, {
        hasError: hasError,
        item: option,
        price: price,
        quantity: preselectedProduct == null ? void 0 : preselectedProduct.quantity,
        imageResize: imageResize,
        onQuantityChange: quantity => {
          handleChange({
            productId: option.value,
            price,
            quantity
          }, Boolean(quantity));
        }
      }) : /*#__PURE__*/React.createElement(TPACheckbox, {
        checked: Boolean(preselectedProduct),
        className: classNames(classes.checkbox, styles.checkbox, {
          [styles.checkboxError]: hasError,
          [classes.hover]: forcedHover
        }),
        "aria-label": `${option.label} ${currencyTranslation}`,
        label: /*#__PURE__*/React.createElement(ProductWUT, {
          item: option,
          price: price,
          imageResize: imageResize
        }),
        onChange: event => {
          handleChange({
            productId: option.value,
            price,
            quantity: 1
          }, event.checked);
        },
        ref: index === 0 ? firstCheckboxRef : undefined
      });
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      id: errorId,
      target: target,
      hasError: hasError,
      errorMessage: errorMessage
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=product-list-wut.js.map